import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CurrentUserService } from '../services/CurrentUserService';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private curentUserService: CurrentUserService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.curentUserService.userContext.isAuthenticated && request.url.indexOf("/api/") >= 0) {
      var sessionToken = this.curentUserService.getSessionToken();
      if (sessionToken) {
        request = request.clone({
          headers: request.headers.set('X-Session-Token', sessionToken)
        });
      }
      if (this.curentUserService.userContext && this.curentUserService.userContext.authToken) {
        request = request.clone({
          headers: request.headers.set('Authorization', 'Bearer ' + this.curentUserService.userContext.authToken)
        });
      }
      return next.handle(request)
        .do((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.curentUserService.setSessionToken(event.headers['X-Session-Token']);
          }
        },
          (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                this.curentUserService.setSessionToken(undefined);
              }
            }
          });
    } else {
      return next.handle(request);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/security/interceptors/TokenInterceptor.ts